import { connect } from 'react-redux';
import { AuthenticatedUser, checkedFetchAccessTokenIfNeeded, logout } from '~/AccessToken';
import Subscription from '~/Api/Authentication/Subscription';
import { ApplicationState } from '~/Store';

import { resetCurrentUserPassword } from './actions';
import UserProfilePage from './UserProfilePage';

const mapStateToProps = (
	state: ApplicationState
): {
	user: AuthenticatedUser | null;
	subscription: Subscription | null;
	isFetching: boolean;
} => {
	const { accessToken } = state.accessToken;

	return {
		user: accessToken !== null ? accessToken.user : null,
		subscription: accessToken !== null ? accessToken.subscription : null,
		isFetching: state.accessToken.isFetching,
	};
};

const actions = {
	onFetch: checkedFetchAccessTokenIfNeeded,
	onResetPassword: resetCurrentUserPassword,
	onLogout: logout,
};

export default connect(mapStateToProps, actions)(UserProfilePage);
